import Creditor from "./Creditor/index";
import {useEffect, useState} from "react";
import Loader from "../../../Loader";
import _axios from "../../../../httpService";

const Index = ({onSubmitAccountSides, newFormData}) => {


    // console.log("newFormData")
    // console.log(newFormData)
    const [bedData, setBedData] = useState([])
    const [besData, setBesData] = useState([])


    function onAddBedTableData(input) {
        // console.log("onAddBedTableData")
        debugger
        setBedData(input)
        onSubmitAccountSides([besData,input])
    }

    function onAddBesTableData(input) {
        // console.log("onAddBedTableData")
        debugger
        setBesData(input)
        onSubmitAccountSides([input,bedData])
    }


    const tableOptions = {
        height: "100%",
        headerSort: false,
        maxHeight: "100%",
        layout: "fitDataStretch",
        printAsHtml: true,
        responsiveLayout: "collapse",
        movableColumns: true, //enable user movable columns
    };


    return (
        <div className={" px-1 "}>
            <div className={"text-center"}>
                تعیین طرف حساب ها
            </div>
            <div className={"row justify-content-around"}>
                <div className={"col-12 col-md-6 mt-3"}>
                    <div className={"text-center"}>بدهکار</div>
                    <Creditor
                        tableOptions={tableOptions}
                        tableType={"بدهکار"}
                        newFormData={newFormData}
                        onSubmit={onAddBedTableData}


                    />
                </div>
                <div className={"col-12 col-md-6 mt-3"}>
                    <div className={"text-center"}>بستانکار</div>


                    <Creditor
                        tableOptions={tableOptions}
                        tableType={"بستانکار"}
                        newFormData={newFormData}
                        onSubmit={onAddBesTableData}
                        setBedData={setBedData}
                        setBesData={setBesData}

                    />


                </div>
            </div>
        </div>
    );
};

export default Index;